import { useEffect, useState } from "react";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";

export const AddRoom = () => {
  const [roomId, setRoomId] = useState("");
  const [roomType, setRoomType] = useState("");
  const [price, setPrice] = useState("");
  const [roomData, setRoomData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isFormDisabled, setIsFormDisabled] = useState(false);

  // Fetch rooms on component load
  useEffect(() => {
    fetchRooms();
  }, []);

  const fetchRooms = async () => {
    // const response = await fetch("https://api.bgmhotel.com/roomName");
    try {
      const response = await fetch("https://api.bgmhotel.com/roomName");
      const data = await response.json();
      setRoomData(data);
    } catch (error) {
      console.error("Error fetching rooms:", error);
    }
  };

  // const submitAddRoomName = async (e) => {
  //   e.preventDefault();
  //   const endpoint = isEditing
  //     ? `https://api.bgmhotel.com/roomName/${roomId}`
  //     : "https://api.bgmhotel.com/roomName";
  //   const method = isEditing ? "PUT" : "POST";

  //   try {
  //     const response = await fetch(endpoint, {
  //       method,
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         id: roomId,
  //         name: roomType,
  //         price: parseFloat(price),
  //       }),
  //     });
  //     const data = await response.json();

  //     if (response.ok) {
  //       console.log(
  //         isEditing ? "Room updated successfully" : "Room added successfully:",
  //         data
  //       );
  //       fetchRooms();
  //       resetForm();
  //     } else {
  //       console.error("Error:", data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  const submitAddRoomName = async (e) => {
    e.preventDefault();

    const endpoint = isEditing
      ? `https://api.bgmhotel.com/rooms/${roomId}`
      : "https://api.bgmhotel.com/roomName";
    const method = isEditing ? "PUT" : "POST";

    try {
      const response = await fetch(endpoint, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: roomId,
          name: roomType,
          price: parseFloat(price),
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // console.log(
        //   isEditing ? "Room updated successfully" : "Room added successfully:",
        //   data
        // );
        fetchRooms(); // Refresh the rooms list
        resetForm(); // Reset the form fields
      } else {
        console.error("Error:", data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const deleteRoom = async (id) => {
    try {
      // Delete from `roomName`
      const roomNameResponse = await fetch(
        `https://api.bgmhotel.com/roomName/${id}`,
        {
          method: "DELETE",
        }
      );

      // Check if deletion from `roomName` is successful
      if (!roomNameResponse.ok) {
        console.error("Error deleting room from roomName collection");
        return; // Exit if `roomName` deletion fails
      }

      // console.log("Room deleted from roomName collection successfully");

      // Delete from `rooms`
      const roomsResponse = await fetch(
        `https://api.bgmhotel.com/rooms/${id}`,
        {
          method: "DELETE",
        }
      );

      // Check if deletion from `rooms` is successful
      if (!roomsResponse.ok) {
        console.error("Error deleting room from rooms collection");
        return; // Exit if `rooms` deletion fails
      }

      // console.log("Room deleted from rooms collection successfully");

      // Refresh the room list
      fetchRooms();
    } catch (error) {
      console.error("Error deleting room:", error);
    }
  };

  const editRoom = (room) => {
    setRoomId(room.id);
    setRoomType(room.name);
    setPrice(room.price.toString());
    setIsEditing(true);
    setIsFormDisabled(true);
  };

  const resetForm = () => {
    setRoomId("");
    setRoomType("");
    setPrice("");
    setIsEditing(false);
    setIsFormDisabled(true);
  };

  const handleRoomTypeChange = (event) => {
    const selectedType = event.target.value;
    setRoomType(selectedType);
    if (!isEditing && selectedType) {
      setRoomId(`${selectedType.slice(0, 3).toUpperCase()}_RM`);
    }
  };

  return (
    <>
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            {isEditing ? "Edit Room Details" : "Add Room Details"} &nbsp;{" "}
            <sup>Add Room Type, ID, Price</sup>
          </button>
        </h2>
        <div
          id="collapseOne"
          className="accordion-collapse collapse show"
          data-bs-parent="#adminPanelRoomDetail"
        >
          <div className="accordion-body">
            <form onSubmit={submitAddRoomName}>
              <div className="input-group py-2">
                <div className="input-group-text">Room ID</div>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={roomId}
                />
              </div>
              <div className="input-group py-2">
                <div className="input-group-text">Room Type</div>
                <select
                  className="form-select"
                  value={roomType}
                  onChange={handleRoomTypeChange}
                  required
                >
                  <option value="">Select Room Type</option>
                  <option value="Normal Room">Normal Room</option>
                  <option value="Standard Room">Standard Room</option>
                  <option value="Luxury Room">Luxury Room</option>
                  <option value="Deluxe Room">Deluxe Room</option>
                  <option value="Super Deluxe Room">Super Deluxe Room</option>
                </select>
              </div>
              <div className="input-group py-2">
                <div className="input-group-text">Room Price per Night</div>
                <div className="input-group-text bg-warning">
                  <LiaRupeeSignSolid />
                </div>
                <input
                  type="number"
                  className="form-control"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                  required
                />
              </div>

              <button
                // className="customButton col-md-3 col-sm-12 col-12 mt-4"
                className=" btn btn-primary-custom col-md-3 col-sm-12 col-12 mt-4 animated slideInLeft"
                type="submit"
              >
                {isEditing ? "Update Room" : "Add Room"}
              </button>
              {isEditing && (
                <button
                  className="btn
                  btn-dark-custom
                  animated
                  slideInRight col-md-3 col-sm-12 col-12 mt-4 ms-md-3"
                  type="button"
                  onClick={resetForm}
                >
                  Cancel Edit
                </button>
              )}
            </form>
            <div className="card col-12 mt-5 amenities">
              <div className="card-header">
                <h6>Room Details Result</h6>
              </div>
              <div className="card-body">
                {/* <div className="col-12 mt-5 amenities"> */}
                <div className="">
                  {/* <h6>Room Details Result</h6> */}
                  <table className="table table-striped">
                    <thead className="table-dark">
                      <tr>
                        <th>Sr. No.</th>
                        <th>ID</th>
                        <th>Room Type</th>
                        <th>Price</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {roomData.map((room, index) => (
                        <tr key={room.id}>
                          <td>{index + 1}</td>
                          <td>{room.id}</td>
                          <td>{room.name}</td>
                          <td>{room.price}</td>
                          <td className="text-success">
                            <AiOutlineDelete
                              title="Delete Record"
                              onClick={
                                !isFormDisabled
                                  ? () => deleteRoom(room.id)
                                  : undefined
                              }
                              style={{
                                cursor: isFormDisabled
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                            />
                            <AiOutlineEdit
                              title="Update Record"
                              onClick={() => editRoom(room)}
                              style={{
                                cursor: "pointer",
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div class="accordion-item">
        <h2 class="accordion-header">
          <button
            class="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            Accordion Item #1
          </button>
        </h2>
        <div
          id="collapseOne"
          class="accordion-collapse collapse show"
          data-bs-parent="#adminPanelRoomDetail"
        >
          <div class="accordion-body">
            <strong>This is the first item's accordion body.</strong> It is
            shown by default, until the collapse plugin adds the appropriate
            classes that we use to style each element. These classes control the
            overall appearance, as well as the showing and hiding via CSS
            transitions. You can modify any of this with custom CSS or
            overriding our default variables. It's also worth noting that just
            about any HTML can go within the
            <code>.accordion-body</code>, though the transition does limit
            overflow.
          </div>
        </div>
      </div> */}
    </>
  );
};
